import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import styles from "./SupEquipmentDetails.module.css";
import { Table } from "antd";
import { InputField, Modal, SubmitButton, TextComponent } from '../../../../components';
import HeaderComponent from '../../../../components/HeaderComponent/HeaderComponent';
import TopTabComponent from '../../../../components/TopTabComponent/TopTabComponent';
import { LuEye, LuEyeOff } from "react-icons/lu";



const tabOptions = [
  { id: 1, name: "Basic Info", },
  { id: 2, name: "Maintenance Log", },
];

const SupEquipmentDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const machineType = params.get("machineType");
  const [focusedMainTab, setFocusedMainTab] = useState(tabOptions[0]);
  const [isModal, setIsModal] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [newLogModal, setNewLogModal] = useState(false)
  const [date, setDate] = useState("")
  const [byName, setByName] = useState("")
  const [notes, setNotes] = useState("")

  const machineParameterData = [
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",
      value: "45",

    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",
      value: "250",
    },

  ];

  const machineColumns = [
    {
      title: "Parameters",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },

  ];

  const [parameterData, setParameterData] = useState([
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",
      value: "45",

    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",
      value: "250",
    },

  ]);

  const columns = [
    {
      title: "Parameters",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },

  ];

  const options = [
    { id: 1, name: "Program 1" },
    { id: 2, name: "Program 2" },
    { id: 3, name: "Program 3" },

  ];
  const [focusedTab, setFocusedTab] = useState(options[0]);

  const leftColumnData = [
    {
      label: "Station",
      text: "Mixing, Oven, Proof / Chill",
    },
    {
      label: "Machine Type",
      text: `${machineType}`,
    },
    {
      label: "Station",
      text: "Mixing, Oven, Proof / Chill",
    },

    {
      label: "Recommended Operator",
      text: "02",
    },
    {
      label: "Skill Level",
      text: "Expert",
    },
    {
      label: "Category",
      text: "Oven",
    },
    {
      label: "Minimum Weight Capacity",
      text: "200 lbs",
    },
    {
      label: "Maximum Weight Capacity",
      text: "300 lbs",
    },
    {
      label: "Maintenance Due(Days)",
      text: "3",
    },


  ]


  const maintenanceColumns = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
    },
    {
      title: "By",
      dataIndex: "By",
      key: "By ",
    },
    {
      title: "Timestamp",
      key: "Timestamp",
      dataIndex: "Timestamp",
    },
    {
      title: "Notes",
      key: "Notes",
      dataIndex: "Notes",
    },
  ];

  const maintenanceData = [
    {
      Date: "2025-08-15",
      By: "John Smith ",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
    {
      Date: "2025-08-15",
      By: "Sarah Jones ",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
    {
      Date: "2025-08-15",
      By: "David Smith ",
      Timestamp: "5:00 PM",
      Notes: "Changed Nut bolts",
    },
  ];

  return (
    <div>
      <HeaderComponent
        heading={"Stand Mixer"}
        onSearch={(e) => console.log(e.target.value)}
        // onSubmit={() => navigate("/CreateNewStaffUser")}
        submitButtonText={false}
        //  onDelete={true}
        // onEdit={onEdit}
        showBackIcon={true}
        showFilterIcon={false}
        showSubmitButton={false}
        showSearch={false}
      >
        <TopTabComponent
          options={tabOptions}
          focused={focusedMainTab}
          setFocused={setFocusedMainTab}
        // TopTabListStyle={styles.TopTabListStyle1}
        />
      </HeaderComponent>
      {focusedMainTab?.name === tabOptions[0]?.name &&
        <div className={styles.mainDetCont}>
          {/* ///////////////////left side details/////////////// */}
          <div className={styles.leftSideCont}>

            {leftColumnData.map((item) =>
              <div >
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  className={styles.leftProText}
                  text={item.label}
                />
                <TextComponent
                  fontFamily={"Inter-semiBold"}
                  text={item.text}
                />
              </div>
            )}

          </div>

          {/* ///////////////////right side details/////////////// */}
          {machineType === "Automatic" && (
            <div className={styles.rightSideCont}>
              <TopTabComponent
                options={options}
                focused={focusedTab}
                setFocused={setFocusedTab}
                TopTabListStyle={styles.TopTabListStyle1}
              />
              <div className={styles.TableDiv}>
                <Table
                  scroll={{ x: true }}
                  columns={columns}
                  dataSource={parameterData}
                  pagination={false}
                  rowKey="parameters"
                />
                {/* {focusedTab == options[0] ? <Program /> : <Mixing />} */}
              </div>

            </div>
          )}

          {machineType === "Manual" && (
            <div className={styles.rightSideCont}>
              <div className={styles.TableDiv}>
                <Table
                  scroll={{ x: true }}
                  columns={machineColumns}
                  dataSource={machineParameterData}
                  pagination={false}
                  rowKey="parameters"
                />
              </div>
            </div>
          )}
        </div>
      }

      {focusedMainTab?.name === tabOptions[1]?.name &&
        <div>
          <div className={styles.btnLog}>
            <SubmitButton
              title={"New Log"}
              btnClass={styles.logBtn}
              primary
              onClick={() => setIsModal(true)

              }
            />
          </div>
          <div className={styles.TableDiv}>
            <Table
              scroll={{ x: true }}
              columns={maintenanceColumns}
              dataSource={maintenanceData}
              pagination={false}
              rowKey="no"
            />
          </div>

        </div>
      }

      {/* ////////////////////Supervisor Password ////////////////////// */}
      <Modal
        open={isModal}
        onCancel={() => {
          setIsModal(false);
        }}
        className={styles.modalCont}
        title={"Enter Supervisor Password"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickCancelButton={() => setIsModal(false)}
        onClickOkButton={() => {
          setIsModal(false)
          setNewLogModal(true)
        }}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <InputField
          className={styles.input}
          labelClass={styles.labelClass}
          label={"Password"}
          placeholder={"12●●●●●●●●●"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          rightIcon={
            passwordVisible ? (
              <LuEye size={20} color={"var(--input-icon)"} />
            ) : (
              <LuEyeOff size={20} color={"var(--input-icon)"} />
            )
          }
          onRightIconPress={() => setPasswordVisible(!passwordVisible)}
          type={passwordVisible ? "text" : "password"}
        />
      </Modal>

      {/* //////////////////// Log ////////////////////// */}
      <Modal
        open={newLogModal}
        onCancel={() => {
          setNewLogModal(false);
        }}
        className={styles.modalCont}
        title={"New Log"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        buttonTitle={"Log"}
        onBtnPress={() => setNewLogModal(false)}
      >
        <div className={styles.modalInputs}>
          <InputField
            className={styles.input}
            labelClass={styles.labelClass}
            label={"Date"}
            placeholder={"2025-08-15"}

            value={date}
            onChange={(e) => setDate(e.target.value)}

          />
          <InputField
            className={styles.input}
            labelClass={styles.labelClass}
            label={"By"}
            placeholder={"John Smith"}
            value={byName}
            onChange={(e) => setByName(e.target.value)}

          />
        </div>
        <InputField
          className={styles.input}
          labelClass={styles.labelClass}
          label={"Notes"}
          placeholder={"Changed Nut bolts.."}
          textArea
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />

      </Modal>


    </div>
  )
}

export default SupEquipmentDetails;
